import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import SimilarSearch from './SimilarSearch';
import {
  getOtherBranchesStart,
  getMoreLikeThisStart,
} from '../SimilarSearch/redux/actions';
import {
  selectOtherBranchesData,
  selectMoreLikeThisData,
} from '../SimilarSearch/redux/selectors';

export const mapDispatchToProps = dispatch => {
  return {
    getOtherBranchesStart: requestData =>
      dispatch(getOtherBranchesStart(requestData)),
    getMoreLikeThisStart: requestData =>
      dispatch(getMoreLikeThisStart(requestData)),
  };
};

export const mapStateToProps = createStructuredSelector({
  otherBranchesData: selectOtherBranchesData,
  moreLikeThisData: selectMoreLikeThisData,
});

export default connect(mapStateToProps, mapDispatchToProps)(SimilarSearch);
